module.exports = __webpack_public_path__ + "static/media/guysgpt.a6abcabe.png";